/* Для модалки подписания документов одной заявки. Обьекты документов - DocumentToSign  */
import { UsbOutlined } from "@ant-design/icons";
import { Badge, Button, Form, Select } from "antd";
import React from "react";
import { SelectSignOneAppProps } from "../../../../interfaces/props/SelectSignOneAppProps";
import {
  UI_ITOModuleDocumentsList,
  UI_ITOModuleSubTitle,
} from "../../../../UI_ITO/indexUI";
import { useDataCrypto } from "../../../../utils/utilities/crypto-pro/useDataCrypto";
import { useAppSelector } from "../../../../store/reduxHooks";
import { SELECT_REQUEST_BANK_DOCUMENTS } from "../../../../store/selectors/requestAppSelector";
import { Certificate } from "crypto-pro";
import { TagTranslation } from "crypto-pro/lib/helpers/_parseCertInfo.d";

import classes from "./SelectSignOneApp.module.css";

export const SelectSignOneApp = ({
  closeModal,
  startSigning,
  applicationBankId,
}: SelectSignOneAppProps) => {
  const { Option } = Select;

  const { dataCrypto } = useDataCrypto();

  const [thumbprint, setThumbprint] = React.useState(""); // отпечаток ЭЦП

  const documentsForSigning = useAppSelector(SELECT_REQUEST_BANK_DOCUMENTS);

  const documentsToSignCount = documentsForSigning?.length || 0; // количество документов для подписания

  // Выбор подписи
  const handleSelectSign = (value: string) => {
    setThumbprint(value);
  };
  return (
    <>
      <div className={classes.wrapperModalSign}>
        <label className={classes.clientLoginFormLabel}>
          <span className={classes.signLableTitle}>Выберите ЭЦП</span>
          <Select
            size="large"
            onChange={handleSelectSign}
            onClick={() => null}
            placeholder={
              <React.Fragment>
                <UsbOutlined /> {" "}
                <span className={classes.placeholderSize}> ЭЦП... </span>
              </React.Fragment>
            }
          >
            {dataCrypto?.map((certificate: Certificate) => {
              const cspNames: string[] = [];
              certificate
                .getOwnerInfo()
                .then((decodedOwnerInfo: TagTranslation[]) => {
                  cspNames.push(
                    `${
                      decodedOwnerInfo.find((info) => info.title === "Владелец")
                        ?.description
                    } (ИНН ${
                      decodedOwnerInfo.find((info) => info.title === "ИНН")
                        ?.description
                    })`,
                  );
                });
              return (
                <Option
                  key={certificate.thumbprint}
                  value={certificate.thumbprint}
                >
                  <Form key={certificate.thumbprint}>
                    <Form.Item className={classes.singModalInput}>
                      {cspNames}
                    </Form.Item>
                  </Form>
                </Option>
              );
            })}
          </Select>
        </label>
        <h3 style={{ marginTop: 5 }}>
          Неподписанные документы
          <Badge
            count={documentsToSignCount}
            color="blue"
            style={{ marginLeft: "10px" }}
          />
        </h3>
        <div style={{ height: 350, overflow: "auto", padding: "0 20px 0 0" }}>
          <UI_ITOModuleSubTitle title={"Документы для подписания"} />
          <UI_ITOModuleDocumentsList
            docs={documentsForSigning}
            applicationBankId={applicationBankId}
          />
        </div>
        <div className={classes.buttons}>
          <Button onClick={closeModal}>Отмена</Button>
          <Button
            disabled={!thumbprint}
            onClick={() =>
              documentsForSigning && startSigning(applicationBankId, thumbprint)
            }
            type="primary"
          >
            Начать процесс подписания
          </Button>
        </div>
      </div>
    </>
  );
};
